var map = {
	"./banner-1920.jpg": 4,
	"./banner-540.jpg": 5,
	"./banner-estudio-1920.jpg": 6,
	"./banner-estudio-1920.jpg.bak.jpg": 7,
	"./banner-estudio-540.jpg": 8,
	"./banner-estudio-540.jpg.bak.jpg": 9,
	"./banner-footer-1920.jpg": 10,
	"./banner-footer-540.jpg": 11,
	"./banner-frase-1920.jpg": 12,
	"./banner-frase-540.jpg": 13,
	"./banner-marcas-1920.jpg": 14,
	"./banner-marcas-540.jpg": 15,
	"./banner-menu-540.jpg": 16,
	"./banner-patentes-1920.jpg": 17,
	"./banner-patentes-540.jpg": 18,
	"./banner-services-1280.jpg": 19,
	"./banner-services-1280.jpg.bak.jpg": 20,
	"./banner-services-540.jpg": 21,
	"./banner-services-540.jpg.bak.jpg": 22,
	"./comilla-der.svg": 23,
	"./comilla-izq.svg": 24,
	"./enviado.svg": 25,
	"./estudio-cuneo-logo.bak.svg": 26,
	"./estudio-cuneo-logo.svg": 27,
	"./favicon.png": 28,
	"./icono-email-w.svg": 29,
	"./icono-email.svg": 30,
	"./icono-telefono-b2.svg": 31,
	"./icono-telefono-w.svg": 32,
	"./icono-telefono.svg": 33,
	"./icono-ubicacion-w.svg": 34,
	"./icono-ubicacion.svg": 35,
	"./icono-whatsapp-w.svg": 36,
	"./icono-whatsapp.svg": 37,
	"./logo-autor-grises.svg": 38,
	"./logo-autor.svg": 39,
	"./logo-marcas-grises.svg": 40,
	"./logo-marcas.svg": 41,
	"./logo-patentes-grises.svg": 42,
	"./logo-patentes.svg": 43,
	"./page-img.jpg": 44
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3;